import { render, staticRenderFns } from "./btn-icon.mpx?vue&type=template&id=551914ec&isComponent&outputPath=components%2Fbtn-icon5927fff2%2Findex"
import script from "./btn-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-icon5927fff2%2Findex"
export * from "./btn-icon.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-icon5927fff2%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports